import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

const resources = {
  en: {
    translation: {
      nav: {
        discover: 'Discover',
        studio: 'Studio',
        social: 'Club',
        wiki: 'Wiki',
        data: 'Data',
        rankings: 'Ranks',
        lists: 'Lists',
        feed: 'Feed',
        recs: 'For you',
        archive: 'Archive',
        fsrs: 'SRS',
      },
      home: {
        heroTitle: 'The reader of machines.',
        heroSubtitle: 'An AI-native literary library.',
        weekStats: 'Week in numbers',
        newTitles: 'New titles',
        minutesRead: 'Minutes read',
        humanMachine: 'Human·machine',
        cidsMinted: 'CIDs minted',
        featured: "This week's picked read",
        beginReading: 'Begin reading',
        details: 'Details',
        aiBlend: 'AI · blend',
        machine: 'machine',
        humanEdit: 'human edit',
        revisions: 'revisions',
        editorRemark: "Editor's remark",
        editor: 'CH. EDITOR',
        filterByAI: 'Filter by AI-blend',
        all: 'All',
        pureAI: 'Pure AI',
        lightCollab: 'Light collab',
        heavyHuman: 'Heavy human',
        newFromArchive: 'New from the archive',
        titles: 'TITLES',
      },
      common: {
        search: 'Search books, authors, CIDs…',
        create: 'Create',
        signIn: 'Sign in',
        join: 'Join',
        signOut: 'Sign out',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        close: 'Close',
        loading: 'Loading…',
        error: 'Error',
        success: 'Success',
        backToHome: 'Back to home',
      },
      reader: {
        chapter: 'Chapter',
        beginReading: 'Begin reading',
        save: 'Save',
        share: 'Share',
        minLeft: 'min left',
        next: 'next',
        exit: 'Exit',
        exitConfirm: 'Your reading progress has been saved. Are you sure you want to exit?',
        annotationSaved: 'Annotation saved successfully',
        annotationError: 'Failed to create annotation',
      },
      wiki: {
        concepts: 'Concepts',
        entities: 'Entities',
        themes: 'Themes',
        timeline: 'Timeline',
        analyses: 'Analyses',
        compiled: 'Compiled',
        lastEdit: 'Last edit',
        revision: 'Revision',
        exportToObsidian: 'Export to Obsidian',
        timelineDate: 'Timeline Date',
        selectDate: 'Select date...',
        addToSRS: 'Add to SRS',
        addedToCards: 'Added to memory cards!',
      },
      fsrs: {
        title: 'Spaced Repetition',
        dueNow: 'Due now',
        dueTomorrow: 'Due tomorrow',
        totalCards: 'Total cards',
        avgDifficulty: 'Avg difficulty',
        avgStability: 'Avg stability',
        startReview: 'Start Review',
        showAnswer: 'Show Answer',
        again: 'Again',
        hard: 'Hard',
        good: 'Good',
        easy: 'Easy',
        completed: 'Review completed!',
        cardsReviewed: 'cards reviewed',
        accuracy: 'Accuracy',
      },
      dashboard: {
        yearReview: 'Your reading · Year in Review · 2026',
        hoursRead: 'You have read for {{hours}} hours.',
        statsSummary: '{{books}} books · {{words}} words · {{notes}} notes · {{exports}} exports',
      },
    },
  },
  zh: {
    translation: {
      nav: {
        discover: '发现',
        studio: '写作台',
        social: '书友圈',
        wiki: '知识宇宙',
        data: '数据',
        rankings: '榜单',
        lists: '书单',
        feed: '动态',
        recs: '推荐',
        archive: '公版',
        fsrs: '记忆',
      },
      home: {
        heroTitle: '机器之书，人之读。',
        heroSubtitle: '一个 AI 原生的文学图书馆。',
        weekStats: '本周数据',
        newTitles: '新作品',
        minutesRead: '阅读分钟',
        humanMachine: '人机比例',
        cidsMinted: 'CID 铸造',
        featured: '本周精选',
        beginReading: '开始阅读',
        details: '详情',
        aiBlend: 'AI 比例',
        machine: '机器',
        humanEdit: '人工编辑',
        revisions: '次修订',
        editorRemark: '编辑评语',
        editor: '主编',
        filterByAI: '按 AI 比例筛选',
        all: '全部',
        pureAI: '纯 AI',
        lightCollab: '轻度人机',
        heavyHuman: '重度人机',
        newFromArchive: '新入档',
        titles: '本',
      },
      common: {
        search: '搜索书籍、作者、CID…',
        create: '创作',
        signIn: '登录',
        join: '加入',
        signOut: '退出',
        save: '保存',
        cancel: '取消',
        delete: '删除',
        edit: '编辑',
        close: '关闭',
        loading: '加载中…',
        error: '错误',
        success: '成功',
        backToHome: '返回首页',
      },
      reader: {
        chapter: '章',
        beginReading: '开始阅读',
        save: '收藏',
        share: '分享',
        minLeft: '分钟剩余',
        next: '下一章',
        exit: '退出',
        exitConfirm: '您的阅读进度已保存。确定要退出吗？',
        annotationSaved: '批注保存成功',
        annotationError: '批注保存失败',
      },
      wiki: {
        concepts: '概念',
        entities: '实体',
        themes: '主题',
        timeline: '时间线',
        analyses: '分析',
        compiled: '编译于',
        lastEdit: '最后编辑',
        revision: '版本',
        exportToObsidian: '导出到 Obsidian',
        timelineDate: '时间线日期',
        selectDate: '选择日期...',
        addToSRS: '加入记忆卡片',
        addedToCards: '已添加到记忆卡片！',
      },
      fsrs: {
        title: '间隔重复',
        dueNow: '待复习',
        dueTomorrow: '明日待复习',
        totalCards: '总卡片',
        avgDifficulty: '平均难度',
        avgStability: '平均稳定性',
        startReview: '开始复习',
        showAnswer: '显示答案',
        again: '重来',
        hard: '困难',
        good: '良好',
        easy: '简单',
        completed: '复习完成！',
        cardsReviewed: '张卡片已复习',
        accuracy: '正确率',
      },
      dashboard: {
        yearReview: '你的阅读 · 年度回顾 · 2026',
        hoursRead: '你已经阅读了 {{hours}} 小时。',
        statsSummary: '{{books}} 本 · {{words}} 字 · {{notes}} 批注 · {{exports}} 导出',
      },
    },
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
